export default "__VITE_ASSET__o41HmeG7__"